import {
  ClientSearchDetail,
  ClientSearchList,
  ClientSearchListParams,
  ClientSearchPracticeCreated,
  ClientSearchPracticePayload,
} from "core/types/client-search.types";
import { ApiFactoryClients } from "../api.types";
import {
  transformClientSearchDetail,
  transformClientSearchList,
  transformClientSearchPracticeCreated,
} from "./client-searches.helpers";

// Contratto con il backend (blueprint /legals, tutte @legal_auth: un 'user' non le
// raggiunge, e non passano per la delega act-as — l'header X-Act-As qui non parte
// nemmeno, core/act-as/act-as.allowlist.ts):
//
//   GET  /legals/searches?user_id&q&limit&offset
//          -> {searches: [{search_id, search_creation_time, full_name, params,
//                          tot_results, owner}], owners_resolved}
//             Ricerche di TUTTI gli account, created_at DESC. limit max 1000.
//   GET  /legals/searches/:id
//          -> {search, owner, results: [{link, title, description, thumbnail, domain,
//                                         sentiment, signaled}]}
//             404 search_not_found | results_missing, 409 owner_mismatch.
//   POST /legals/searches/:id/practice {urls, customer_name?, confirm_suspended?}
//          -> 201 {id, owner_id, customer_name, urls, skipped_already_in_practice,
//                  owner_suspended}
//             La pratica e' intestata al PROPRIETARIO della ricerca e non scala crediti.
//             409 owner_suspended finche' confirm_suspended non e' true.

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ codeHttpClient }: ApiFactoryClients<"codeHttpClient">) => ({
  list: (params: ClientSearchListParams = {}): Promise<ClientSearchList> =>
    codeHttpClient
      .get("/legals/searches", {
        // axios omette i parametri undefined: senza filtri la query resta vuota.
        params: {
          user_id: params.userId || undefined,
          q: params.q || undefined,
          limit: params.limit,
          offset: params.offset,
        },
      })
      .then(({ data }) => transformClientSearchList(data)),
  detail: (searchId: number): Promise<ClientSearchDetail> =>
    codeHttpClient
      .get(`/legals/searches/${searchId}`)
      .then(({ data }) => transformClientSearchDetail(data)),
  createPractice: (
    searchId: number,
    payload: ClientSearchPracticePayload
  ): Promise<ClientSearchPracticeCreated> =>
    codeHttpClient
      .post(`/legals/searches/${searchId}/practice`, {
        urls: payload.urls,
        customer_name: payload.customerName,
        confirm_suspended: payload.confirmSuspended,
      })
      .then(({ data }) => transformClientSearchPracticeCreated(data)),
});
